module.exports = __webpack_public_path__ + "static/media/close.3e288aa3.svg";